module.exports = __webpack_public_path__ + "static/media/logo_dark.40f2511b.svg";